<template>
  <div class="c-offline-class-wrap bg-lightgrey" :style="{'min-height': clientHeight + 'px'}">
    <list-top :active="2" ref="listTop"></list-top>
    <div class="c-fixed" :class="showFixed ? 'show': 'hide'">
      <div class="c-cats-wrap" ref="cats1">
        <!-- <div
          class="item"
          :id="'cats1-all'"
          :class="this.curCid == '' ? 'active' : ''"
          @click="changeCat('')"
        >
          全部
          <span></span>
        </div>-->
        <template v-for="c in cats" :key="c.id">
          <div
            class="item"
            :class="curCid == c.id ? 'active' : ''"
            :id="'cats1-'+c.id"
            @click="changeCat(c.id)"
          >
            {{c.name}}
            <span></span>
          </div>
        </template>
      </div>
    </div>
    <div class="c-fixed">
      <div class="c-cats-wrap" ref="cats2">
        <!-- <div
          class="item"
          :id="'cats2-all'"
          :class="curCid == '' ? 'active' : ''"
          @click="changeCat('')"
        >
          全部
          <span></span>
        </div>-->
        <template v-for="c in cats" :key="c.id">
          <div
            class="item"
            :class="curCid == c.id ? 'active' : ''"
            :id="'cats2-'+c.id"
            @click="changeCat(c.id)"
          >
            {{c.name}}
            <span></span>
          </div>
        </template>
      </div>
    </div>
    <ul>
      <li v-for="it in list.records" :key="it.resourceId">
        <list-item :item="it" @click="jumpToCourse(it)"></list-item>
      </li>
    </ul>
    <div class="nomore" v-if="!nodata && !showLoading">— 没有更多课程啦，看看其他课程吧 —</div>
    <gxxt-no-data v-if="nodata"></gxxt-no-data>
    <GxxtPageLoading v-show="showLoading"></GxxtPageLoading>
  </div>
  <footer-nav :active="1" v-if="!origin"></footer-nav>
</template>

<script>
import { GxxtTag, GxxtPageLoading, GxxtNoData } from '@/components'
import { wxShare } from '@/utils/wx-config'
import ListItem from './components/online-course-item.vue'
import footerNav from '@/pages/public/footer-nav.vue'
import listTop from './components/list-top'
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'

export default {
  components: {
    GxxtTag,
    GxxtPageLoading,
    ListItem,
    footerNav,
    listTop,
    GxxtNoData,
  },
  data() {
    return {
      cats: [],
      curCid: -1,
      list: {
        records: [],
      },
      origin: '', //来源
      goodsType: this.constants.goodsType.training,
      nodata: false,
      more: false,
      showMask: false,
      showLoading: false,
      cityLoading: false,
      adminId: '',
      showFixed: false,
    }
  },
  created() {
    this.origin = this.$route.query.origin
    this.adminId = this.$route.query.adminId
    this.getCourseList()
  },
  unmounted() {
    this.removeScroll()
  },
  mounted() {
    // this.shareOut()
    this.getCats()
    this.bindScroll()
  },
  methods: {
    jumpToCourse(item) {
      this.$router.push({
        name: 'course-home',
        query: {
          goodsId: item.id,
          adminId: this.$route.query.adminId ? this.$route.query.adminId : '',
          origin: this.$route.query.origin,
          goodsType: item.type,
        },
      })
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.showLoading = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction

      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        let showTop = 640 * this.ratio
        if (this.$refs.listTop.carouselList.length == 0) {
          showTop = 340 * this.ratio
        }
        if (scrollTop >= showTop) {
          this.showFixed = true
        } else {
          this.showFixed = false
        }
        if (this.showLoading) {
          return
        }
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    async getCats() {
      let res = await this.api.course.getCourseCats()
      if (res && res.code == 200) {
        this.cats = res.data
      }
    },
    changeCat(cid) {
      if (cid == this.curCid) return
      this.curCid = cid
      this.list = {
        records: [],
      }
      this.getCourseList()

      let w = 686 * this.ratio
      let ofl = document.getElementById(
        'cats2-' + (cid ? cid : 'all')
      ).offsetLeft
      let sl = ofl - w / 2
      // if (sl > 0) {
      this.$refs['cats2'].scrollLeft = sl
      // }

      let w1 = 686 * this.ratio
      let ofl1 = document.getElementById(
        'cats1-' + (cid ? cid : 'all')
      ).offsetLeft
      let sl1 = ofl1 - w1 / 2
      // if (sl1 > 0) {
      this.$refs['cats1'].scrollLeft = sl1
      // }
    },
    async getCourseList({ more = false } = {}) {
      if (more && !this.more) return
      this.showLoading = true
      let prev = '',
        ln = this.list.records.length
      prev =
        this.list.records[ln - 1] && this.list.records[ln - 1].publishTime
          ? this.list.records[ln - 1].publishTime
          : ''
      let res = await this.api.course.getGoodsList({
        classifyId: this.curCid,
        prev: prev,
        goodsType: this.constants.goodsType.course,
      })
      if (res && res.code == 200) {
        if (more) {
          res.data.records.forEach((item) => {
            this.list.records.push(item)
          })
        } else {
          if (
            Object.prototype.toString.call(res.data.records) !=
              '[object Array]' ||
            res.data.records.length == 0
          ) {
            this.nodata = true
          } else {
            this.nodata = false
          }
          if (
            Object.prototype.toString.call(res.data.records) == '[object Array]'
          ) {
            this.list = res.data
          }
        }
        this.more = res.data.more
      }
      this.showLoading = false
    },
    loadMoreFn() {
      if (this.showLoading || !this.more) {
        return false
      }
      this.getCourseList({ more: true })
    },
    shareOut() {
      let link = location.href
      let shareInfo = {
        title: '更新学堂',
        desc: 'CEO的新商业学堂',
        link: link,
        imgUrl: this.constants.logo,
      }
      let callback = () => {}
      wxShare({ shareInfo, callback })
    },
  },
}
</script>
<style lang="less" scoped>
.hide {
  display: none;
}

.c-offline-class-wrap {
  text-align: left;
  padding: 40px 32px 146px;
  li {
    border-bottom: 1px solid #e4e4e4;
    padding: 40px 0;
  }
}

.nomore {
  padding: 20px 0 40px;
  text-align: center;
  color: #888888;
  font-size: 28px;
}
.nodata {
  padding: 120px 0 60px;
  text-align: center;
  color: #888888;
  font-size: 28px;
}
.c-label {
  font-size: 36px;
  font-weight: 500;
  color: #303030;
  line-height: 96px;
}
.c-fixed {
  // position: fixed;
  top: 0;
  width: 750px;
  left: 0;
  background-color: #f7f7f9;
  z-index: 2;
  &.show {
    display: flex;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
  }
}
.show {
  padding-bottom: 30px;
  .c-cats-wrap {
    padding-left: 32px;
    margin-bottom: 0;
  }
}
::-webkit-scrollbar {
  display: none;
}
.c-cats-wrap {
  display: flex;
  overflow: auto;
  height: 86px;
  padding: 20px 0 0px 0;
  scroll-behavior: smooth;
  margin-bottom: -10px;
  .item {
    font-size: 30px;
    font-weight: 500;
    color: #888888;
    line-height: 66px;
    margin-right: 50px;
    position: relative;
    white-space: nowrap;
  }
  .active {
    color: #333;
    span {
      width: calc(100% - 10px);
    }
  }
  span {
    display: block;
    width: 0;
    position: absolute;
    height: 6px;
    border-radius: 3px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #f50;
    transition: width 0.3s;
  }
}
</style>